export default "__VITE_ASSET__xEBaXOpe__"